<template>
  <div id="salemarket">
    <my-header></my-header>
    <div class="pd20">
      <div class="sale-market search-controls">
        <sale-market-head></sale-market-head>
        <p class="all-types">
          <a
            v-for="(item) in list_status"
            :key="item.id"
            v-bind:class="{active:search_params.status == item.id}"
            v-on:click="changeStatus(item.id)"
          >{{ item.name }} ({{item.count}})</a>
        </p>
        <loading class="mt10" :text="'Please wait'|translate" v-if="list_orders ===null"></loading>
        <p
          class="mt10 alert alert-warning"
          v-if="list_orders && list_orders.length==0"
        >{{'No order'|translate}}</p>
        <div class="list-orders" v-if="list_orders && list_orders.length > 0">
          <h4 class="pd5">{{total_order_count}} {{'order'|translate}}</h4>
          <div class="order-item" v-for="(order) in list_orders" :key="order.id">
            <div class="shop-info">
              <p class="shop-link">
                <router-link :to="{ name: 'SaleMarketStore', params: { store_id: order.store_id }}">
                  <i class="fas fa-store-alt"></i>
                  {{order.store_name}}
                </router-link>
              </p>
              <div class="pull-right">
                <p class="status">{{ map_status[order.status] }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <p>
                  <i class="fas fa-shopping-cart"></i>
                  <strong>{{'Items'|translate}}</strong>:
                </p>
                <ul class="list-group">
                  <li class="list-group-item" v-for="(item) in order.items" :key="item.id">
                    <img :src="getProductFeatureImage(item.product_id)" />
                    <div class="item-name">
                      <p class="inline">
                        <router-link
                          :to="{ name: 'SaleAdMarketDetail', params: { ad_id: item.ad_id}}"
                        >{{item.varriant_name}}</router-link>
                        <p>
                          <i class="fas fa-truck"></i>
                          {{item.source_name}} ({{item.source_type|translate}})
                        </p>
                        <span>{{toCommas(item.price_unit)}} x {{item.quantity}} = {{ toCommas(item.price_unit * item.quantity) }} {{'price_unit'|translate}} ({{'Estimated'|translate}})</span>
                      </p>
                      <div class="mt10">
                        <p class="inline">
                          {{'Updated total price by seller'|translate}}:
                          <span
                            v-if="item.update_total_price > 0 "
                          >{{toCommas(item.update_total_price)}} {{'price_unit'|translate}} ({{'Final price'|translate}})</span>
                          <span v-if="item.update_total_price == 0 ">{{'Not update yet'|translate}}</span>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-md-6">
                <p>
                  <i class="fas fa-map-marker"></i>
                  <strong>{{'Delivery info'|translate}}</strong>:
                </p>
                <div class="group-s">
                  <p>{{'Address'|translate}}: {{order.address}}</p>
                  <p>{{'Phone'|translate}}: {{order.phone}}</p>
                  <p>{{'Email'|translate}}: {{order.email}}</p>
                </div>
                <div class="actions mt10">
                  <p class="inline">
                    <i class="fas fa-clock"></i>
                    {{ order.add_date | moment("from", "now") }}
                  </p>
                  <p class="mt10">
                    <i class="fas fa-tag"></i>
                    {{'Total price (unit_price)'|translate}} :
                    {{ toCommas(totalPrice(order)) }}
                  </p>
                  <div class="btn-group pull-right">
                    <button
                      type="button"
                      v-if="order.status == status_waiting"
                      v-on:click="cancelOrder(order)"
                      class="btn btn-warning"
                    >{{'Cancel'|translate}}</button>
                    <button
                      type="button"
                      v-if="order.status == status_delivering"
                      v-on:click="updateOrder(order,status_finished)"
                      class="btn btn-primary"
                    >{{'I received'|translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <paginate
            v-if="total_page > 1"
            :page-count="total_page"
            :click-handler="clickPage"
            :prev-text="'Prev'|translate"
            :next-text="'Next'|translate"
            v-model="page"
            :container-class="'pagination'"
          ></paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";
import SaleMarketHead from "@/components/SaleMarket/SaleMarketHead";
import Paginate from "vuejs-paginate";
export default {
  name: "SaleMarketOrderList",
  components: {
    MyHeader,
    Loading,
    SaleMarketHead,
    Paginate
  },
  data() {
    let data = {
      status_waiting: 0,
      status_confirmed: 1,
      status_delivering: 2,
      status_finished: 3,
      status_cancel: 4,
      list_status: [
        { id: "", name: this.$t("All"), count: 0 },
        { id: "0", name: this.$t("Waiting confirm"), count: 0 },
        { id: "1", name: this.$t("Seller confirmed"), count: 0 },
        { id: "2", name: this.$t("Delivering"), count: 0 },
        { id: "3", name: this.$t("Finished"), count: 0 },
        { id: "4", name: this.$t("Cancel"), count: 0 }
      ],
      map_status: null,
      working: false,
      list_orders: null,
      total_order_count: null,
      total_page: 1,
      page: 1,
      allProducts: null,
      mapProductImage: {},
      search_params: {
        limit: Utils.getLimit(),
        offset: 0,
        type: "buyer",
        status: ""
      }
    };

    return data;
  },

  methods: {
    toCommas(value) {
      return Utils.toCommas(value);
    },
    totalPrice(order) {
      let total = 0;

      order.items.forEach(item => {
        if (item.update_total_price) {
          total += parseFloat(item.update_total_price);
        } else {
          total += parseFloat(item.price_unit * item.quantity);
        }
      });
      return total;
    },
    getOrders() {
      this.list_orders = null;
      this.working = true;
      Utils.request(this, true, "salemarket")
        .get(`/manageOrder/?${Utils.arrayToRequestParam(this.search_params)}`)
        .then(response => {
          this.working = false;
          let data = response.data;

          if (data.status === "ok") {
            let list = data.data.list;

            for (let index = 0; index < list.length; index++) {
              list[index].show_detail = false;
              let temp = new Date(parseInt(list[index].add_time) * 1000);
              list[index].add_date = this.$moment(temp);
            }

            this.list_orders = list;
            let group_count = data.data.group_count;
            // reset
            for (let j = 0; j < this.list_status.length; j++) {
              this.list_status[j].count = 0;
            }

            for (let i = 0; i < group_count.length; i++) {
              let item = group_count[i];
              item.count = parseInt(item.count);
              this.list_status[0].count += item.count;

              for (let j = 1; j < this.list_status.length; j++) {
                if (item.status == this.list_status[j].id) {
                  this.list_status[j].count += item.count;
                }
              }
            }
            let total = 0;
            for (let j = 0; j < this.list_status.length; j++) {
              if (this.list_status[j].id == this.search_params.status) {
                total = this.list_status[j].count;
              }
            }
            //list_status
            this.total_order_count = total;
            this.total_page = Utils.getTotalPages(this.total_order_count);
          }
        })
        .catch(error => {
          this.working = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    changeStatus(status) {
      this.search_params.status = status;
      this.search_params.offset = 0;
      this.getOrders();
    },
    clickPage(pageNum) {
      this.search_params.offset = Utils.getNextOffset(
        pageNum,
        this.search_params.limit
      );
      this.getOrders();
    },
    getProductFeatureImage(productId) {
      return this.mapProductImage[productId]
        ? this.mapProductImage[productId]
        : "";
    },
    getAllProducts() {
      Utils.getAllProducts(this, {}).then(data => {
        this.allProducts = data;
        this.allProducts.forEach(product => {
          this.mapProductImage[product.id] = product.feature_image_path;
        });
      });
    },
    updateOrder(order, new_status) {
      let message_confirm;
      switch (new_status) {
        case this.status_cancel:
          message_confirm = "Are you sure to cancel this order ?";
          break;
        case this.status_finished:
          message_confirm = "Are you sure to set this order as finished ?";
          break;
      }
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t(message_confirm),
        () => {
          this.removing = true;
          let temp = JSON.parse(JSON.stringify(order));
          temp.status = new_status;
          temp.action = "update_status";
          Utils.request(this, true, "salemarket")
            .put(
              `/manageOrder/?${Utils.arrayToRequestParam({
                type: this.search_params.type
              })}`,
              temp
            )
            .then(response => {
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.getOrders();
              }
            });
        }
      );
    }
  },
  mounted() {
    this.getAllProducts();
    this.map_status = Utils.arrayToObject(this.list_status);
    this.getOrders();
  },
  beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/SaleMarket/SaleMarketOrderList.vue